import { createFileRoute } from '@tanstack/react-router';
import { S1Attention } from '@/screens/S1Attention/S1Attention';
import { useApiClients } from '@/app/ApiProvider';
import { useApiConfig } from '@/app/ApiProvider';

// /$orgId/ — the org's home page, rendering S1 Attention. Pre-org-scope
// this lived at /; index.tsx still exists as a redirect to here.
export const Route = createFileRoute('/$orgId/')({
  component: AttentionHome,
});

function AttentionHome() {
  const clients = useApiClients();
  const config = useApiConfig();
  return <S1Attention clients={clients} config={config} />;
}
